import "@fortawesome/fontawesome-svg-core/styles.css";
import {
  MenuItem,
  Select,
  InputLabel, FormControl,TextField
} from "@mui/material";
import "aos/dist/aos.css";
import React, { useEffect, useRef, useState } from "react";
import "../../components/styles.css";
import "../../components/swiper.css";
import "../../components/user/whyichest.css";
import { toast } from "react-toastify";
import { myAxios } from "../../services/helper";

import { Container, Nav, Navbar } from "react-bootstrap";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import FooterPage from "./footer";

const ContactUs = () => {
  const line1 = "Life is about legacy,".split(" ");
  const line2 = "I-Chest.com helps preserve it !!!".split(" ");
  const first = "Life is about legacy, I-Chest.com helps preserve it !!!".split(
    " "
  );
  const [key, setKey] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    inquiryType: "",
    phoneNumber: "",
    email: "",
    subject: "",
    message: "",
  });
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
const handleFileChange = (e) => {
  const selectedFiles = Array.from(e.target.files);
  const oversized = selectedFiles.find(file => file.size > 5 * 1024 * 1024);
  if (oversized) {
    toast.error("Each file must be less than 5MB");
    return;
  }
  setFiles(selectedFiles);
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (event, newValue) => {
    setFormData({ ...formData, inquiryType: newValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name , inquiryType, phoneNumber, email, subject, message } = formData;

    const requiredFields = {
      name: "Please fill your name before submitting.",
      inquiryType: "Please select an inquiry type before submitting.",
      email: "Please fill your email before submitting.",
      subject: "Please fill the subject before submitting.",
      message: "Please fill out the message section before submitting.",
    };

    for (const [field, warning] of Object.entries(requiredFields)) {
      if (!formData[field]) {
        toast.warning(warning);
        return;
      }
    }

  
    const form = new FormData();
    form.append("name", name);
    form.append("inquiryType", inquiryType);
    form.append("phoneNumber", phoneNumber);
    form.append("email", email);
    form.append("subject", subject);
    form.append("message", message);
  
  files.forEach(file => {
  form.append("files", file);
  });
  
    try {
      const response = await myAxios.post("/api/contact/submit", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      toast.success("Your message has been sent successfully!");
      setFormData({
        name: "",
        inquiryType: "",
        phoneNumber: "",
        email: "",
        subject: "",
        message: "",
      });
      setFiles([]);
      if (fileInputRef.current) {
      fileInputRef.current.value = "";  
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to send message. Please try again later.");
    }
  };
  
  useEffect(() => {
    const interval = setInterval(() => {
      setKey((prevKey) => prevKey + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  
  return (
    <>
      <div className="homepage_design_main">
        <div className="homepage_design_main">
          <Navbar
            expand="lg"
            fixed="top"
            bg="dark"
            variant="dark"
            aria-label="Main navigation"
            className="navbar_base"
          >
            <Container>
              <Navbar.Brand href="#" className="navbar-brand logo-image">
                <img src="./logo192.webp" alt="alternative" />
                <div className="App_this">
                  <div className="tab_largescreen_view">
                    {first.map((el, i) => (
                      <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                          duration: 1,
                          delay: i / 10,
                        }}
                        key={i + key * first.length}
                      >
                        {el}{" "}
                      </motion.span>
                    ))}
                  </div>
                  <div className="tab_movile_view">
                    {line1.map((el, i) => (
                      <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                          duration: 1,
                          delay: i / 10,
                        }}
                        key={i + key * line1.length}
                      >
                        {el}{" "}
                      </motion.span>
                    ))}
                  </div>
                  <div className="tab_movile_view">
                    {line2.map((el, i) => (
                      <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                          duration: 0.25,
                          delay: i / 10,
                        }}
                        key={i + key * line2.length}
                      >
                        {el}{" "}
                      </motion.span>
                    ))}
                  </div>
                </div>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="navbar-nav" />
              <Navbar.Collapse id="navbar-nav">
                <Nav className="ms-auto">
                  <Nav.Link href="/">Home</Nav.Link>
                  {/* <Nav.Link href="/services">Services</Nav.Link> */}
                  {/* <Nav.Link href="/features">Features</Nav.Link> */}
                  {/* <Nav.Link href="/">Partners</Nav.Link> */}
                  {/* <Link className="partner" to="/home#aboutus">
                    Partners
                  </Link> */}
                  <Nav.Link href="/WhyI-chest">Why I-chest</Nav.Link>
                  <Nav.Link href="#">Contact Us</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>

        <div className={`your-component fade-in-element`}>        
          <div className="contact_us_form_main">
            <div className="contact_us_form_detail">
              <div className="contact_us_form_fields">
                <form className="contact_us_form" onSubmit={handleSubmit}>
                  <div className="contact_us_title">Contact us</div>
                  <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Your name *"
                        className="input"
                      />
                 <FormControl fullWidth >
                  <InputLabel id="inquiryType-label">Select an option</InputLabel>
                  <Select
                    labelId="inquiryType-label"
                    id="inquiryType"
                    value={formData.inquiryType}
                    onChange={(e) => handleSelectChange(e, e.target.value)}
                    label="Select an option"
                  >
                    <MenuItem value="" disabled>
                      Select an option
                    </MenuItem>
                    <MenuItem value="general">General Inquiry</MenuItem>
                    <MenuItem value="support">Support</MenuItem>
                    <MenuItem value="feedback">Feedback</MenuItem>
                  </Select>
                </FormControl>
                  <input
                    label = "phoneNumber"
                    type="number"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    placeholder="Phone number"
                    className="input"
                  />
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your email *"
                    className="input"
                  />
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="subject-label">Subject</InputLabel>       
                    <Select
                        labelId="subject-label"
                        id="subject"
                        name="subject"
                        value={formData.subjectType === "Others" ? "Others" : formData.subject}
                        label="Subject"
                        onChange={(e) => {
                          const selected = e.target.value;
                          if (selected === "Others") {
                            setFormData((prev) => ({ ...prev, subject: "", subjectType: "Others" }));
                          } else {
                            setFormData((prev) => ({ ...prev, subject: selected, subjectType: "Preset" }));
                          }
                        }}
                    >
                      <MenuItem value="" disabled>Select a Subject</MenuItem>
                      <MenuItem value="Email Already Registered">Email Already Registered</MenuItem>
                      <MenuItem value="Invalid Email Format">Invalid Email Format</MenuItem>
                      <MenuItem value="QR code is not loading">QR code is not loading</MenuItem>
                      <MenuItem value="OTP Not Received">OTP Not Received</MenuItem>
                      <MenuItem value="OTP Expired or Incorrect">OTP Expired or Incorrect</MenuItem>
                      <MenuItem value="Unable to Complete Registration">Unable to Complete Registration</MenuItem>
                      <MenuItem value="Forgot Password / Reset Not Working">Forgot Password / Reset Not Working</MenuItem>
                      <MenuItem value="Account Locked or Disabled">Account Locked or Disabled</MenuItem>
                      <MenuItem value="Site Not Loading Properly">Site Not Loading Properly</MenuItem>
                      <MenuItem value="Submit Button Not Working">Submit Button Not Working</MenuItem>
                      <MenuItem value="Confused About Registration Steps">Confused About Registration Steps</MenuItem>
                      <MenuItem value="Need Help to Register">Need Help to Register</MenuItem>
                      <MenuItem value="Want a Callback or Demo">Want a Callback or Demo</MenuItem>
                      <MenuItem value="Others">Others</MenuItem>
                    </Select>
                    </FormControl>

                    {formData.subjectType === "Others" && (
                      <TextField
                          label="Custom Subject *"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          fullWidth
                          sx={{ mb: 2 }}
                        />
                      )}              
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Your message *"
                  ></textarea>
                  <input
                    type="file"
                    multiple
                    onChange={handleFileChange}
                    accept=".jpg,.png,.pdf,.docx,.jpeg"
                    ref={fileInputRef}
                  />
                  <button type="submit"  className="contact_us_btn">Submit</button>
                </form>
              </div>
              <div className="contact_us_form_img">
                <LazyLoadImage
                  className="whyichest_image_img"
                  src="/img/contact-us.webp"
                  alt="secure_data_image "
                  effect="blur"
                />
              </div>
            </div>
          </div>
           <div className="whyichest_base">
            <div className="whyichest_main">
              <div className="whyichest_heading">
                <h2 style={{ marginTop: "1rem" }}>
                  Business Opportunities and Investments
                </h2>
              </div>
              <div className="whyichest_paragraph">
                <p>
                 I-Chest.com* is seeking forward-thinking investors and strategic partners—both nationally and internationally—to
                 join us in advancing a revolutionary platform for asset management and estate planning.
                </p>
              </div>
              <br />

              <div className="whyichest_second_para">
                <div className="whyichest_image">
                  <LazyLoadImage
                    className="whyichest_image_img"
                    src="/img/business_investment.webp"
                    alt="secure_data_image "
                    effect="blur"
                  />
                </div>
                <div className="whyichest_content">
                  <p>
                    We welcome submissions from individuals, venture capital firms, and organizations interested in contributing to the growth of a secure,
                    innovative, and customer-centric digital ecosystem.


                  </p>
                  <br />
                  <p>
                    By investing in I-Chest, you’ll help drive technological innovation, enhance user experience,
                    and expand our global reach—while participating in a venture redefining how wealth and personal legacies are managed.

                  </p>
                  <br />
                   <div className="whyichest_last_para">
                        <p>
                              To explore partnership or investment opportunities, please contact us at{" "}
                              <a
                                href="mailto:contact@i-chest.com"
                                style={{ color: '#007BFF', textDecoration: 'underline' }}
                              >
                                contact@i-chest.com
                              </a>.
                              Together, we can shape the future of digital asset management.
                            </p>
                    </div>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
        <FooterPage />
      </div>
    </>
  );
};
export default ContactUs;
